import { LETTER_SPACING_EM_RANGE, LINE_HEIGHT_RANGE, MAX_FONT_SIZE_MM } from '@repo/api-contracts';

export interface NumberRange {
  readonly min: number;
  readonly max: number;
}

/**
 * 텍스트 속성 패널이 맞추는 범위 — 계약(designDocumentSchema) 상수를 그대로 쓴다.
 * 글자 크기는 계약상 0 초과면 되지만 입력 칸의 최소(1mm)에 맞춘다.
 */
export const TEXT_LIMITS = {
  fontSizeMm: { min: 1, max: MAX_FONT_SIZE_MM },
  letterSpacingEm: LETTER_SPACING_EM_RANGE,
  lineHeight: LINE_HEIGHT_RANGE,
} as const satisfies Record<string, NumberRange>;

export const clampTo = (value: number, range: NumberRange): number =>
  Math.min(range.max, Math.max(range.min, value));
